import { create } from 'zustand';

export type ToastVariant = 'default' | 'success' | 'destructive' | 'info' | 'warning';
export interface Toast { id: string; title: string; description?: string; variant: ToastVariant; }

interface ToastState {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id'>) => void;
  dismiss: (id: string) => void;
}

let counter = 0;
export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = `t-${Date.now()}-${++counter}`;
    set({ toasts: [...get().toasts, { ...t, id }] });
    setTimeout(() => get().dismiss(id), 5000);
  },
  dismiss: (id) => set({ toasts: get().toasts.filter(t => t.id !== id) })
}));

export const toast = {
  success: (title: string, description?: string) => useToastStore.getState().push({ title, description, variant: 'success' }),
  error:   (title: string, description?: string) => useToastStore.getState().push({ title, description, variant: 'destructive' }),
  info:    (title: string, description?: string) => useToastStore.getState().push({ title, description, variant: 'info' }),
  warn:    (title: string, description?: string) => useToastStore.getState().push({ title, description, variant: 'warning' })
};
